<template>
  <div class="e4s-flex-column">
    <div class="e4s-flex-row e4s-justify-flex-space-between">
      <div class="e4s-flex-row e4s-gap--standard e4s-header--500">
        <div v-text="payload.eventGroup.typeNo + ':'"></div>
        <div v-text="payload.eventGroup.name"></div>
      </div>
    </div>

    <LiveFeedHeatAthletes :athletes="payload.heatSummary" />
  </div>
</template>
<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type {
  LiveFeedMessageBase,
  LiveFeedMessageTrackResult
} from '@/components/results/socket/live-feed/live-feed-models'
import LiveFeedHeatAthletes from '@/components/results/socket/live-feed/LiveFeedHeatAthletes.vue'

const props = defineProps({
  message: {
    type: Object as PropType<LiveFeedMessageBase>,
    required: true
  }
})

const payload = computed<LiveFeedMessageTrackResult>(() => {
  return props.message.payload as LiveFeedMessageTrackResult
})
</script>
